module.exports = __webpack_public_path__ + "static/img/whatsapp-qr.f524f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/whatsapp-qr.png
// module id = YT0N
// module chunks = 2